import { TeamAccessDTO } from '../team/team-access.dto';

export class ProductCheckpointQuestionListDTO extends TeamAccessDTO {

    id: string;

    question: string;
    
}
